import { useRef, useState, createElement } from 'react';
import { useDrag } from '@use-gesture/react';
const classPrefix = `au-dragbar`;
const Thumb = props => {
    const { value, min, max, onDrag } = props;
    const [dragging, setDragging] = useState(false);
    const prevValue = useRef(value);
    const currentPosition = () => {
        return {
            left: `${((value - min) / (max - min)) * 100}%`,
            right: 'auto',
        };
    };
    const bind = useDrag(state => {
        if (state.first) {
            prevValue.current = value;
        }
        const x = state.xy[0] - state.initial[0];
        const sliderOffsetWith = props.trackRef.current?.offsetWidth;
        if (!sliderOffsetWith)
            return;
        const diff = (x / Math.ceil(sliderOffsetWith)) * (max - min);
        if (prevValue.current) {
            onDrag(prevValue.current + diff, state.first, state.last);
        }
        else {
            onDrag(diff, state.first, state.last);
        }
        setDragging(!state.last);
    }, {
        axis: 'x',
        pointer: { touch: true },
    });
    const thumbElement = (createElement("div", { className: `${classPrefix}-thumb` },
        createElement("svg", { viewBox: "0 0 20 20", className: `${classPrefix}-thumb-icon` },
            createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                createElement("g", { transform: "translate(-604.000000, -656.000000)", fill: "#999999" },
                    createElement("g", { transform: "translate(592.000000, 644.000000)" },
                        createElement("g", { transform: "translate(12.000000, 12.000000)" },
                            createElement("polygon", { points: "0 3.33333333 2.22222222 3.33333333 2.22222222 17.7777778 0 17.7777778" }),
                            createElement("polygon", { points: "17.7777778 3.33333333 20 3.33333333 20 17.7777778 17.7777778 17.7777778" }),
                            createElement("path", { d: "M10.8888889,0 L9.11111111,0 C8.98888889,0 8.88888889,0.107142857 8.88888889,0.238095238 L8.88888889,19.7619048 C8.88888889,19.8928571 8.98888889,20 9.11111111,20 L10.8888889,20 C11.0111111,20 11.1111111,19.8928571 11.1111111,19.7619048 L11.1111111,0.238095238 C11.1111111,0.107142857 11.0111111,0 10.8888889,0 Z" }))))))));
    return (createElement("div", { className: `${classPrefix}-thumb-container`, style: currentPosition(), ...bind(), role: 'slider' }, thumbElement));
};
export default Thumb;
